import styled from 'styled-components';

export const StyleWrap = styled.div`
  .page-body {
    text-align: center;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    min-height: 600px;

    .content {
      position: relative;
      margin: 80px auto 0px;
      width: 590px;
      .alert-message {
        padding: 90px 130px 0px 130px;
        position: relative;
        z-index: 5;
        h4 {
          font-size: 21px;
          font-weight: 500;
          color: #212121;
        }
        p {
          font-size: 14px;
          font-weight: 400;
          color: #212121;
        }
        a {
          font-size: 14px;
          font-weight: 400;
          color: #1357ff;
        }
      }
      img {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 4;
      }
    }
  }
`;
